import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Switch from '@material-ui/core/Switch';

interface Props {
  value: boolean;
  onChange: (field: string, value: any) => void;
}

function AllowUninvited({ value, onChange }: Props) {
  const handleChangeAllowNewProfiles = () => {
    onChange('client.settings.login.blockCreatedAccounts.enabled', value);
  };

  return (
    <Card>
      <CardHeader
        title="Automatically allow new profiles to sign in"
        action={
          <Switch
            checked={value}
            inputProps={{ 'aria-label': 'allow uninvited sign-in switch' }}
            onChange={handleChangeAllowNewProfiles}
          />
        }
        subheader=" If enabled, new users will automatically be allowed to sign into Sift on our login site
            when their profiles are created in Sift. This is most helpful when utilizing single sign
            on (SSO), so that users will not need to be invited in order to access the system. If
            you’d like to require users to be invited before they can sign in, turn this setting
            off."
      />
    </Card>
  );
}

export default AllowUninvited;
